import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { FaHeart } from 'react-icons/fa';
import { GiFlowerEmblem } from 'react-icons/gi';
import '../../../assets/css/customer/home/ServicesSection.css';

const ServicesSection = () => {
  const navigate = useNavigate();

  // Services data
  const services = [
    {
      id: 1,
      title: 'Music & DJ',
      image: 'https://i.pinimg.com/1200x/1d/a7/d9/1da7d93ad41ed44b2e0a2ab06152d782.jpg',
      description: 'Beautiful backdrop walls for your special day'
    },
    {
      id: 2,
      title: 'Floral Arrangements',
      image: 'https://i.pinimg.com/1200x/86/a9/f2/86a9f25b935e14327af47b1c87535881.jpg',
      description: 'Elegant circular floral arrangements'
    },
    {
      id: 3,
      title: 'Photographer',
      image: 'https://i.pinimg.com/736x/f6/ad/44/f6ad44658b7f8320480281c439e4975e.jpg',
      description: 'Stunning chair decorations and setups'
    },
    {
      id: 4,
      title: 'Catering',
      image: 'https://images.unsplash.com/photo-1555244162-803834f70033?w=600&h=400&fit=crop',
      description: 'Exquisite dining experiences'
    }
  ];

  // Navigate to Services page
  const handleViewServices = () => {
    navigate('/services');
  };

  return (
    <section className="ss-services-section">
      <Container>
        {/* Decorative Icons */}
        <div className="ss-decorative-icons">
          <div className="ss-icon-heart-pink">
            <FaHeart />
          </div>
          <div className="ss-icon-heart-mint">
            <FaHeart />
          </div>
          <div className="ss-icon-mandala">
            <GiFlowerEmblem />
          </div>
        </div>

        <Row>
          {/* Left Side - Service Cards Grid (SWAPPED) */}
          <Col lg={7} md={12} className="ss-services-cards-col">
            <div className="ss-services-grid">
              {services.map((service) => (
                <div key={service.id} className="ss-service-section-card">
                  <div className="ss-service-image-wrapper">
                    <img 
                      src={service.image} 
                      alt={service.title} 
                      className="ss-service-image"
                    />
                    <div className="ss-service-overlay">
                      <div className="ss-overlay-content">
                        <h3 className="ss-service-title">{service.title}</h3>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </Col>

          {/* Right Side - Content (SWAPPED) */}
          <Col lg={5} md={12} className="ss-services-content-col">
            <div className="ss-services-content">
              {/* Main Heading */}
              <h1 className="ss-services-heading">
                Explore Our Wedding Services
              </h1>

              {/* Description */}
              <p className="ss-services-description">
                Discover a wide range of wedding services including decoration, catering, and venue styling to make your special day perfectly organized and memorable.
              </p>

              {/* View Services Button - Navigate to /services */}
              <button 
                className="ss-btn-learn-more-services"
                onClick={handleViewServices}
              >
                View Services
              </button>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default ServicesSection;